import escapeName from '../escapeName';
import toDashCase from '../toDashCase';

const stringtoSlug = (str: string) => toDashCase(escapeName()(str));

export default stringtoSlug;
